
import {
  Mixins,
  Component,
  Prop,
} from 'vue-property-decorator';
import PopupMixin from './mask';

@Component
export default class TDialog extends Mixins(PopupMixin) {
  @Prop({
    type: String,
    default: 'slide-fade',
  }) fadename!: string;

  @Prop({
    type: Boolean,
    default: true,
  }) autoWidth!: boolean;

  @Prop({
    type: Boolean,
    default: true,
  }) isMiddle!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  }) show!: boolean;

  @Prop({
    type: String,
    default: '',
  }) title!: string;

  @Prop({
    type: Boolean,
    default: true,
  }) showClose!: boolean;

  @Prop({
    type: String,
    default: '360px',
  }) width!: string;

  @Prop({
    type: String,
    default: '',
  }) top!: string;

  @Prop() beforeClose?: Function;

  @Prop({
    type: Boolean,
    default: true,
  }) handleClickModal!: boolean;

  @Prop({
    type: Boolean,
    default: true,
  }) handleEscModal!: boolean;

  get style() {
    const css:any = {};
    if (this.width) css.width = this.width;
    if (this.top) css.top = this.top;
    return css;
  }

  // 模态框点击 关闭 和  右上角按钮关闭
  handleClose(v: string) {
    if (v !== 'modal' || this.handleClickModal) this.$emit('beforeClose', 'dialog');
  }
}
